export default "__VITE_ASSET__BSo5GdQX__"